import { withRouter } from "react-router-dom";
import { composeValidators, isBlockedDomain, isEmail, isRequired } from "../../utils/validate";
import { useTranslate } from '../../customHooks';
import { useGetUserRolesAndPermissionsQuery } from '../../redux/services/user-roles-service';
import { FormProvider, useForm } from "react-hook-form";
import { FormLayout, Input, Select, SubmitButton } from "@panwds/react-form";
import { Button, Sheet, SheetBody } from "@panwds/react-ui";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import { toast } from "../../components";

const UserManagementSheet = (props: any) => {
  const { close, userData, onSubmit, loading } = props;
  const translate = useTranslate();
  const { data: roleChoices, error: roleChoicesnError, isLoading: roleChoicesLoading } = useGetUserRolesAndPermissionsQuery();
  const formMethods = useForm({ defaultValues: userData || {} });
  const {
    formState: { dirtyFields },
  } = formMethods

  useEffect(() => {
    if (roleChoicesnError) {
      toast.error(roleChoicesnError?.error, { toastId: "describe-permission-policy" });
    }
  }, [roleChoicesnError]);

  return (
    <>
      <Sheet
        onClose={() => close()}
        title={!isEmpty(userData) ? translate(`resources.users.fields.UpdateUser`) : translate(`resources.users.fields.InviteUser`)}
        isOpen
        showMask={true}
        position="sm"

      >
        <SheetBody isLoading={loading}>
          <div className={`formLayout`} style={{ position: 'relative' }}>
            <FormProvider {...formMethods}>
              <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                <FormLayout>
                  <Input
                    label={translate(`resources.users.fields.FirstName`)}
                    name="FirstName"
                    dataMetrics="cloudngfw-users-create-first-name"
                    requiredAsterisk
                  />
                  <Input
                    label={translate(`resources.users.fields.LastName`)}
                    name="LastName"
                    dataMetrics="cloudngfw-users-create-field-last-name"
                    requiredAsterisk
                  />
                  <Input
                    label={translate(`resources.users.fields.UserName`)}
                    name="UserName"
                    dataMetrics="cloudngfw-users-create-field-email"
                    requiredAsterisk
                    register={{
                      required: true, validate: (value) => value === "" ||
                        composeValidators(isRequired,
                          isBlockedDomain,
                          isEmail)(value)
                    }}
                  />
                  <Select
                    items={roleChoices}
                    label={translate(`resources.users.fields.Roles`)}
                    name="Permissions"
                    dataMetrics={"cloudngfw-user-invite-roles"}
                    isLoading={roleChoicesLoading}
                    enableMultiSelect
                    simpleFormat
                    fitToItemWidth
                  />
                  <div className="tw-flex tw-justify-end">
                    <Button addClassName="tw-mr-2" onClick={() => close()} disabled={isEmpty(dirtyFields)}
                      dataMetrics="cloudngfw-users-create-cancel">
                      {translate(`generic.cancel`)}
                    </Button>
                    <SubmitButton disabled={isEmpty(dirtyFields)} dataMetrics="cloudngfw-users-create-save">
                      {translate(`generic.save`)}
                    </SubmitButton>
                  </div>
                </FormLayout>
              </form>
            </FormProvider>
          </div>
        </SheetBody>
      </Sheet>
    </>
  );
};

export default withRouter(UserManagementSheet);
